import { Component, Inject, OnInit } from '@angular/core';
import { POPUP_DATA } from '../../../services/modal/modal.service';
import { PopUpComponent } from '../pop-up.component';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ToastService } from 'src/app/@shared/services/toast/toast.service';
import { CLOSE, LINK_COPIED } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    templateUrl: './share-link-pop-up.component.html',
    styleUrls: ['./share-link-pop-up.component.scss'],
    standalone: false
})
export class ShareLinkPopUpComponent extends PopUpComponent implements OnInit {
  link: string;
  /**
   * a11y: localized aria-label for the new top close (X) button. Required by
   * the audit so every popup exposes a focusable close target at its top.
   */
  closeText: string = 'Close';
  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,

    @Inject(POPUP_DATA)
    public readonly data: { link: string },
    private readonly router: Router,
    private readonly toastService: ToastService,
    private readonly languageService: LanguageService
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  /** After copy from modal: same audible feedback as desktop share (aria-live via ToastService). */
  onLinkCopied(copied: boolean): void {
    if (!copied) {
      return;
    }
    const lang = this.languageService.getSelectedLanguage().language;
    this.toastService.showToast(LINK_COPIED[lang], {
      position: 'top-right',
      duration: 2000,
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.link = this.data?.link ?? `${window.location.origin}${this.router.url}`;
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.closeText = CLOSE[language.language];
    });
  }
}
